module.exports = __webpack_public_path__ + "img/status3.5155abe.svg";